import React from 'react';
import PropTypes from 'prop-types';
import '../styles/RatingDisplay.css';

const RatingDisplay = ({ rating, totalRatings, showCount = true, size = 'medium' }) => {
  // Handle cases where rating might be null or undefined
  const averageRating = rating || 0;
  const count = totalRatings || 0;

  // Generate star elements
  const renderStars = () => {
    const stars = [];
    const fullStars = Math.floor(averageRating);
    const hasHalfStar = averageRating % 1 >= 0.5;

    // Full stars
    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <span key={`full-${i}`} className="star full-star">
          ★
        </span>
      );
    }

    // Half star
    if (hasHalfStar) {
      stars.push(
        <span key="half" className="star half-star">
          ★
        </span>
      );
    }

    // Empty stars
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(
        <span key={`empty-${i}`} className="star empty-star">
          ★
        </span>
      );
    }

    return stars;
  };

  // Don't render anything if no ratings
  if (count === 0) {
    return null;
  }

  return (
    <div className={`rating-display ${size}`}>
      <div className="stars">
        {renderStars()}
      </div>
      {showCount && (
        <span className="rating-count">
          ({count})
        </span>
      )}
    </div>
  );
};

RatingDisplay.propTypes = {
  rating: PropTypes.number,
  totalRatings: PropTypes.number,
  showCount: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large'])
};

export default RatingDisplay; 